<template>
  <div class="hello">
    <nav class="navbar navbar-inverse site-navbar">
      <div class="yem-top">
        <div class="container"></div>
      </div>
      <div class="top-logo">
        <div class="container">
          <div class="row">
            <div class="pull-left">
              <a href="index.html">
                <img src="../../assets/images/logo.png" class="logo-index" />
              </a>
            </div>
            <div class="pull-right">
              <p><i class="glyphicon glyphicon-earphone"></i>0411-82817405</p>
            </div>
          </div>
        </div>
      </div>
      <div class="about-nav-py">
        <div class="container">
          <div class="navbar-header">
            <img src="../../assets/images/logo.png" class="meblie-logo" />
            <button
              type="button"
              class="navbar-toggle collapsed jicheng"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
          </div>
          <div id="navbar" class="collapse navbar-collapse">
            <ul class="nav navbar-nav nav-top-quanju">
             <li>
                <router-link to="/">首页</router-link>
              </li>
              <li>
                <router-link to="/aboutPage" class="active-daohang">企业介绍</router-link>
              </li>
              <li>
                <router-link to="/contactPage">联系我们</router-link>
              </li>
              <li>
                <a href="javascript:void(null);" @click="openRegisteredDialog">注册</a>
              </li>
              <li>
                <a href="javascript:void(null);"  @click="openLoginDialog">登录</a>
              </li>
            </ul>
          </div>
          <!--/.nav-collapse -->
        </div>
      </div>
    </nav>
    <div id="wrapper">
      <div class="fullwidthbanner-container">
        <div class="fullwidthbanner">
          <ul>
            <li
              data-transition="papercut"
              data-slotamount="15"
              data-masterspeed="300"
              data-link="#"
            >
              <img src="../../assets/images/slide2.jpg" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="about-us">
      <div class="container">
        <div class="row">
          <div class="clearfix">
            <div class="col-md-12 clearfix about-company">
              <div class="col-md-12 new-title clearfix">
                <h2>
                  <i></i>
                  <span>公司简介</span>
                  <i></i>
                </h2>
              </div>
              <div class="col-md-6 about-img">
                <img src="../../assets/images/pic22.jpg" />
              </div>
              <div class="col-md-6 about-jianjie" style="text-align: left">
                <p>
                  WIFFA是中国国际海运网在2011年发起并创办的中国最大国际货代信用合作平台，旨在汇聚中国货代优势，形成中国货代力量，创造中国货代财富。目前在国内建立24个口岸分会、18个海外分会、18个专项联盟委员会，国内外货代信用合作会员超过千家。WIFFA平台会员年业务存量超过700万TEU，年业务额超过千亿元人民币。
                  “舱哪儿云”是“携程式”货代在线供舱交易平台，为创盈货代而生。平台为货代与货代订舱提供交易、支付和融资三大保证。从2019年6月5日试运行以来，行业高度青睐，目前已有全国30多个口岸400多家有船东签约的货代在线供舱，订舱用户5万家，覆盖中国各个口岸到世界各地航线。
                </p>
              </div>
            </div>
            <div class="col-md-12 new-title clearfix about-linian">
              <h2>
                <i></i>
                <span>企业理念</span>
                <i></i>
              </h2>
            </div>
            <div class="col-md-12">
              <ul class="clearfix company-linian">
                <li class="col-md-4">
                  <div>
                    <img src="../../assets/images/phi1.jpg" />
                  </div>
                  <div class="col-md-10 company-jianjie">
                    <p class="phiTop wow fadeInLeft" data-wow-delay=".2s">
                      质量第一
                    </p>
                    <p class="phiMiddle">Quality</p>
                  </div>
                </li>
                <li class="col-md-4">
                  <div>
                    <img src="../../assets/images/phi1.jpg" />
                  </div>
                  <div class="col-md-10 company-jianjie" data-wow-delay=".4s">
                    <p class="phiTop wow fadeInLeft">服务第一</p>
                    <p class="phiMiddle">Service</p>
                  </div>
                </li>
                <li class="col-md-4">
                  <div>
                    <img src="../../assets/images/phi1.jpg" />
                  </div>
                  <div class="col-md-10 company-jianjie" data-wow-delay=".6s">
                    <p class="phiTop wow fadeInLeft">信誉第一</p>
                    <p class="phiMiddle">Reputation</p>
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-md-12 about-lishi clearfix">
              <h2>
                <i></i>
                <span>发展历程</span>
                <i></i>
              </h2>
              <section id="cd-timeline" class="cd-container">
                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-picture">
                    <img
                      src="../../assets/images/cd-icon-picture.svg"
                      alt="Picture"
                    />
                  </div>

                  <div class="cd-timeline-content">
                    <h2>2017年，起航</h2>
                    <p>公司迎接挑战，未来创造新起点！</p>
                  </div>
                </div>

                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-movie">
                    <img
                      src="../../assets/images/cd-icon-movie.svg"
                      alt="Movie"
                    />
                  </div>

                  <div class="cd-timeline-content">
                    <h2>2016年，公司进一步发展</h2>
                    <p>公司规模逐渐增大，发展越来越好！</p>
                  </div>
                </div>

                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-picture">
                    <img
                      src="../../assets/images/cd-icon-picture.svg"
                      alt="Picture"
                    />
                  </div>

                  <div class="cd-timeline-content">
                    <h2>2015年，朝气蓬勃</h2>
                    <p>吸收大量有朝气的年轻人加入，未来发展令人期待</p>
                  </div>
                </div>

                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-location">
                    <img
                      src="../../assets/images/cd-icon-location.svg"
                      alt="Location"
                    />
                  </div>

                  <div class="cd-timeline-content">
                    <h2>2014年，公司稳步前进</h2>
                    <p>打好基础，筑建伟梦</p>
                  </div>
                </div>

                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-location">
                    <img
                      src="../../assets/images/cd-icon-location.svg"
                      alt="Location"
                    />
                  </div>

                  <div class="cd-timeline-content">
                    <h2>2013年</h2>
                    <p>公司发展稳中有升</p>
                  </div>
                </div>

                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-movie">
                    <img
                      src="../../assets/images/cd-icon-movie.svg"
                      alt="Movie"
                    />
                  </div>
                  <div class="cd-timeline-content">
                    <h2>2012年</h2>
                    <p>筑梦</p>
                  </div>
                </div>
                <div class="cd-timeline-block">
                  <div class="cd-timeline-img cd-movie">
                    <img
                      src="../../assets/images/cd-icon-movie.svg"
                      alt="Movie"
                    />
                  </div>
                  <div class="cd-timeline-content">
                    <h2>2011年</h2>
                    <p>起步</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3">版权所有：国际海运网</div>
          <div class="col-md-3">联系电话：0411-82817405</div>
          <div class="col-md-3">联系人：刘先生</div>
          <div class="col-md-3">
            联系地址：辽宁省大连市中山区人民路50号时代广场B座1601
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 footer-bottom">Copyright © 2020-2025</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogRegisteredVisible" width="500px" :close-on-click-modal="false">
      <Register :isShow="dialogRegisteredVisible"></Register>
    </el-dialog>

    <el-dialog class="no-bg" :visible.sync="dialogLoginVisible" width="500px" :close-on-click-modal="false">
      <Login></Login>
    </el-dialog>
  </div>
</template>

<script>
  import Login from '@/views/home/login/Login.vue'
  import Register from '@/views/home/register/Register.vue'
export default {
  name: 'aboutPage',
  components: {Login, Register},
  data () {
    return {
      dialogRegisteredVisible: false,
      dialogLoginVisible: false,
      form: {
        name: '',
        region: ''
      },
      formLabelWidth: '120px'
    }
  },
  methods: {
    openRegisteredDialog: function () {
      this.dialogRegisteredVisible = true
    },
    openLoginDialog: function () {
      this.dialogLoginVisible = true
    }
  }
}
</script>
<!--<style scoped>
@import "../../assets/css/bootstrap.min.css";
@import "../../assets/css/tf.css";
@import "../../assets/css/style1.css";
</style>-->
<style src="../../assets/css/bootstrap.min.css" scoped></style>
<style src="../../assets/css/tf.css" scoped></style>
<style src="../../assets/css/style1.css" scoped></style>
<style scoped>
  /* /deep/ .no-bg .el-dialog, .el-pager li {
    box-shadow: 0 1px 3px rgba(0,0,0,0);
    background: #FFFFFF00;
  } */
</style>